import RatingHalfCard from './RatingHalfCard';

export default RatingHalfCard;
